import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/sass/estilos-generales.scss' 
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import filters from "@/filters"
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Multiselect from '@vueform/multiselect'
import "@vueform/multiselect/themes/default.css"

axios.defaults.baseURL = '/api/'
axios.defaults.withCredentials = true
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
const app = createApp(App).use(store).use(router).use(VueAxios, axios).use(VueSweetalert2)

app.component("Multiselect", Multiselect)
app.config.globalProperties.$filters = filters
app.config.globalProperties.estatusRespuesta = { OK: 0, ALERT: 1, INFO: 2, ERROR: 3, NO_AUTORIZADO: 4 }
app.mixin({
    methods: {
        notificar: function(notificacion) {
            var icon;
            var title;
        
            switch (notificacion.Estatus) {
                case this.estatusRespuesta.OK:
                    icon = "success";
                    title = "Éxito";
                    break;
                case this.estatusRespuesta.ALERT:
                    icon = "warning";
                    title = "Atención";
                    break;
                case this.estatusRespuesta.ERROR:
                    icon = 'error';
                    title = "Error";
                    break;
                case this.estatusRespuesta.INFO:
                    icon = "info";
                    title = "Información";
                    break;
                case this.estatusRespuesta.NO_AUTORIZADO:
                    icon = "error";
                    title = "No Autorizado";
            }
            this.$swal({
                icon: icon,
                title: title,
                confirmButtonText: 'Aceptar',
                text: notificacion.Mensaje
            }).then((result) => {
                if (result.isConfirmed) {
                    if(typeof(notificacion.Callback) === 'function')
                        notificacion.Callback();
                }
            });
      }
    }
  })
app.mount('#app')
